import { AccountTypeEnum } from "../lib/auth";

interface ICurrentUser {
	userId: string;
	sessionId: string;
	accountId: string;
	accountType: AccountTypeEnum;
	role: "owner" | "user" | "fdir_admin";
}

class CurrentUser implements ICurrentUser {
	userId: string;
	sessionId: string;
	accountId: string;
	accountType: AccountTypeEnum;
	role: "owner" | "user" | "fdir_admin";

	constructor(currentUser: ICurrentUser) {
		this.userId = currentUser.userId;
		this.sessionId = currentUser.sessionId;
		this.accountId = currentUser.accountId;
		this.accountType = currentUser.accountType;
		this.role = currentUser.role;
	}

	get isOwner() {
		return this.role === "owner" || this.role === "fdir_admin";
	}
}

export default CurrentUser;
